import React from 'react';
import styled from 'styled-components';
import * as Atoms from '../../atoms';
import * as Molecules from '../../molecules';
import { localI18n } from '../../../i18n';
const uxCopy = {
  header: localI18n._("Access settings")
};
const HeaderWrapper = styled.div.withConfig({
  displayName: "IndividualAccess__HeaderWrapper",
  componentId: "sc-9wy8yl-0"
})(["display:flex;flex-direction:row;column-gap:16px;align-items:center;padding:8px 0 12px;"]);
const IndividualAccess = () => {
  return React.createElement("div", null, React.createElement(HeaderWrapper, null, React.createElement(Atoms.Dumb.SectionHeader, null, uxCopy.header), React.createElement(Molecules.Smart.ViewLinkPrivacyDropdown, null)), React.createElement(Molecules.Smart.AddCollaborator, null), React.createElement(Molecules.Smart.Organization, null), React.createElement(Molecules.Smart.CollaboratorList, null));
};
export default IndividualAccess;